var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_331",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H111V111H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3796 89.8253V93.2854C15.3796 95.1911 16.9232 96.7368 18.8289 96.7368H57.2043",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7826 8.53754H81.4703C83.376 8.53754 84.9217 10.0833 84.9217 11.9889V63.8164",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4731 1.62606H74.3313C76.2367 1.62606 77.7827 3.17183 77.7827 5.07747V8.53755V63.8164",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2043 89.8254H15.3796H11.6899C9.78429 89.8254 8.23853 88.2797 8.23853 86.374V27.4274",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.761 84.3238V100.332C102.761 105.326 98.7132 109.374 93.7195 109.374H66.2454C61.2517 109.374 57.2035 105.326 57.2035 100.332V72.8581C57.2035 67.8644 61.2517 63.8161 66.2454 63.8161H93.7195C98.7132 63.8161 102.761 67.8644 102.761 72.8581V76.7335",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23889 19.8298L26.473 1.62583V16.3791C26.473 18.2849 24.9281 19.8298 23.0223 19.8298H8.23889Z",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0018 88.9792L72.6522 84.6298C71.8164 83.794 70.4614 83.794 69.6259 84.6298L66.7859 87.4696C65.9501 88.3054 65.9501 89.6603 66.7859 90.4959L74.0618 97.7718C75.5698 99.2798 78.0146 99.2798 79.5225 97.7718L93.7502 83.5441C94.5857 82.7083 94.5857 81.3533 93.7502 80.5178L91.1198 77.8874C90.2843 77.0517 88.9293 77.0517 88.0935 77.8874L77.0018 88.9792Z",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8362 41.0813H39.1008C37.5496 41.0813 36.2917 39.8237 36.2917 38.2723V13.5368C36.2917 11.9856 37.5496 10.728 39.1008 10.728H63.8362C65.3876 10.728 66.6453 11.9856 66.6453 13.5368V38.2723C66.6453 39.8237 65.3876 41.0813 63.8362 41.0813Z",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 53.7214H66.1592",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 61.9438H45.3846",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0637 70.1665H45.3846",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 70.1665H32.4809",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 78.3892H45.3846",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5771 41.0813L24.9205 35.7381",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4774 29.3772C49.3305 29.3772 47.5896 27.6368 47.5896 25.4894V23.7177C47.5896 21.5703 49.3305 19.8299 51.4774 19.8299C53.6246 19.8299 55.3652 21.5703 55.3652 23.7177V25.4894C55.3652 27.6368 53.6246 29.3772 51.4774 29.3772Z",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1596 29.3773H49.7951C46.4708 29.3773 43.776 32.0723 43.776 35.3967V41.0813H59.1788V35.3967C59.1788 32.0723 56.484 29.3773 53.1596 29.3773Z",
    stroke: "#7F1767",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.cfae27be16ae8ade8adbbd984e8bcfe2.svg";
export { ForwardRef as ReactComponent };